import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import { Link } from 'react-router'

import Icon from '../../shared/components/Icon'

@inject('auth') @observer
export default class ListEntry extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      acs: PropTypes.shape({
        isAuthorized: PropTypes.func.isRequired
      }).isRequired
    }).isRequired,
    editable: PropTypes.bool.isRequired,
    museum: PropTypes.object.isRequired,
  }

  render() {
    const { auth, museum, editable } = this.props
    const linkTo = editable
      ? `/museum/${museum.id}/edit`
      : `/museum/${museum.id}`

    const isAdmin = auth.acs.isAuthorized('ADMIN')

    return (
      <li className="museum iconized">
        <div>
          <Icon
            size={18}
            name={`${museum.isDirty ? 'cancel' : 'ok'}-color`}
            title="erfordert Freigabe"
          />
          <Link to={linkTo}>
            {museum.name}
            {isAdmin && !museum.isLive
              ? <strong>&nbsp;[Keine Live-Version]</strong>
              : null}
          </Link>
          <span className="tools pull-right">
            <Link to={linkTo}>
              <svg
                className="tool-icon"
                width="18"
                height="18"
              >
                <use xlinkHref="#icon-envelope-turquoise" />
              </svg>
            </Link>
          </span>
        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/museum/components/ListEntry.js